import { FilterOneItem } from "../model/FilterOneItem";

export const DATA_TYPE_CONSULT = {
  SERVICE: {
    SERVICE_TEMPLATE: "serviceTemplate",
    SERVICE_CATEGORY: "serviceCategory",
    SERVICES_CUPS: "servicesCups",
    SERVICE_LEVEL: "serviceLevel"
  },
  FORM: {
    FORM_TEMPLATE: "formTemplate",
    FORM_TEMPLATESCHEMA: "formTemplateSchema"
  },
  USER: {
    ROLE: "role",
    DEPENDENCY: "dependency",
    USER_TEMPLATE: "userTemplate",
    USER_SCHEMA: "userSchema"
  },
  MEDICALORDER: {
    ORDER_CUPS: "orderCups",
    ORDER_STATE: "orderState",
    ORDER_SERVICE: "orderService",
    ORDER_CODE: "orderCode",
    ORDER_TEMPLATE_SCHEMA: "orderTemplateSchema"
  },
  SESSION: {
    SESSION_TEMPLATES: "sessionTemplates"
  }
};

export const EVENT_EMITTER = {
  CALL_DATA: "callData",
  EDIT_DATA: "editData",
  CHANGE: "change",
  CHILDREN_RELOAD: "childrenReload",
  SELECTED: "selected",
  FILTER_OUT: "filterOut",
  CREATE_NEW_ELEMENT: "createNewElement",
  SELECT_ITEM: "selectItem",
  UPDATE_SELECT_FILTER: "update:selectFilter",
  UPDATE_ALL_SELECT_FILTER: "update:allSelectFilter",
  CLOSE_SEARCH: "closeSearch",
  SEARCH_TEXT: "searchText",
  EDIT_AVAILABILITY_NAME: "editAvailabilityName"
};

export const GENERIC_SEARCH_LABELS = {
  OPERACION: "operacion",
  SEARCH_INPUT_TEXT: "Nombre de usuario"
};

export const FIELD_ROOT = {
  id: "root",
  name: "Campos",
  check: false,
  children: []
};

export const NAME_FILTER = {
  USER: "Usuario"
};

export const ID_FILTER = {
  CREATED_BY: "createdBy",
  USER: "user",
  NAME: "name",
  CATEGORY: "category",
  SUB_CATEGORY: "subCategory",
  STATE: "state",
  INTERNAL_NAME: "internalName"
};

export const ONE_FILTER_ITEM_VOID = { id: "", name: "" };

export const SEARCH_COLLECTION = "Buscar coleccion";

export const FILTER_SEARCH_USER_GENERIC_SEARCH: FilterOneItem = {
  labelTitle: " del usuario",
  labelNotFound: "No se encontró usuario para esa busqueda",
  labelAddTitle: "No se encontró usuario con esta busqueda",
  labelAddSubTitle: " Crear nuevo usuario",
  addIcon: "mdi-plus-circle-outline",
  defaultUpdate: "userDocument",
  filters: [
    { name: "Nombre", id: "name", default: true },
    {
      name: "Documento",
      id: "userDocument",
      oneResult: true
    },
    { name: "Correo", id: "userEmail", oneResult: true }
  ]
};

export const MESSAGE_SNACKBAR = {
  FILTER_DATA_REGISTER: "ya existe"
};

export const EMPTY_OBJ_STRING = "{}";

export const WEEK_AS_MS = 604800000;

export const DAY_AS_MS = 86400000;
